module.exports = __webpack_public_path__ + "static/img/account.4de6d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/account.jpg
// module id = 2xey
// module chunks = 0